import ContactSupportButton from "@/components/ContactSupportButton";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { ImportantNote } from "@/components/ui/importantNote";
import { Typography } from "@/components/ui/typography";

type NoCreditsModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};
export default function NoCreditsModal({ isOpen, setIsOpen }: NoCreditsModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={() => setIsOpen(false)}>
      <DialogContent>
        <div className="mt-4 md:max-h-auto flex max-h-[380px]  flex-col overflow-auto">
          <DialogTitle asChild>
            <Typography variant="text-lg" weight="semibold" className="text-center mb-2">
              No Credits
            </Typography>
          </DialogTitle>
          <DialogDescription asChild>
            <ImportantNote>Your organization has no credits. Please contact us for help.</ImportantNote>
          </DialogDescription>
          <ContactSupportButton
            subject="Credits"
            onClick={() => setIsOpen(false)}
            className="mt-4 flex items-center gap-2 self-center"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
